import { CompassIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useDocumentTitle } from '@/shared/lib/use-document-title';
import { Button } from '@/shared/ui/button';
import { EmptyState } from '@/shared/ui/empty-state';
import { PageLayout } from '@/shared/ui/page-layout';

/**
 * The one not-found state: an unknown path, or an org, workspace or project the person cannot see. It never
 * says which, so nothing hints that something exists.
 */
export function NotFoundPage() {
  const { t } = useTranslation('org');
  useDocumentTitle(t('notFound.title'));
  return (
    <PageLayout title={t('notFound.title')} width="narrow">
      <EmptyState
        icon={<CompassIcon />}
        title={t('notFound.title')}
        description={t('notFound.help')}
        action={
          <Button asChild variant="secondary">
            <Link to="/">{t('notFound.home')}</Link>
          </Button>
        }
      />
    </PageLayout>
  );
}
